"use strict";

import {getMovingStateOfVehicle} from "./../../utils/vehicle";

function filterByText(vehicles, text) {
	return vehicles.filter(vehicle => {
		
		const pattern = new RegExp(text, "i");
		
		if (vehicle.name && pattern.test(vehicle.name))
			return true;
		if (vehicle.plateNumber && pattern.test(vehicle.plateNumber))
			return true;
		if (vehicle.make && pattern.test(vehicle.make))
			return true;
		return false;
	});
}

function filterByMovement(dataTypeStore, vehicles, vehicleStates, movement) {
	
	if (!vehicleStates)
		return [];
	
	return vehicles.filter(vehicle => {
		
		const movingState = getMovingStateOfVehicle(vehicle._id);
		
		if (movement == 'igOff' && movingState == '')
			return true;
		if (movement == 'igOn' && (movingState == 'onIgnition' || movingState == 'moving'))
			return true;
		if (movement == 'moving' && movingState == 'moving')
			return true;
		
		return false;
	});
}

export default function filterVehicles(dataTypeStore, vehicles, vehicleStates, expression) {
	if (!vehicles)
		return null;
	
	if (!expression.text && !expression.movement)
		return null;
	
	let filteredVehicles = vehicles.slice();
	
	if (expression.text)
		filteredVehicles = filterByText(filteredVehicles, expression.text);
	
	if (expression.movement)
		filteredVehicles = filterByMovement(dataTypeStore, filteredVehicles, vehicleStates, expression.movement);
	
	return filteredVehicles;
}


// WEBPACK FOOTER //
// ./src/view/VehicleList/filterVehicles.js